export const counter = () => {
  const counters = document.querySelectorAll('[data-counter]');
  const speed = 300;
  let time_out = 50;

  counters.forEach( counter => {
    const value = counter.getAttribute('data-counter');

    if (value > 1000) {
      time_out = 1;
    } else if (value > 500) {
      time_out = 10;
    }
    const animate = () => {
      const value =+ counter.getAttribute('data-counter');
      const data =+ counter.innerText;



      const time = value / speed;
      if(data < value) {
        counter.innerText = Math.ceil(data + time);
        setTimeout(animate, time_out);
      }else{
        counter.innerText = value;
      }
    }

    counter.addEventListener('appear', ()=> {
      animate();
    })
  });
}
